/* JS to add click event listeners to the main menu `menu--main.html.twig` */
import getKeyboardFocusableElements from '../accessibility/getKeyboardFocusableElements';

let isSearchOpen = false;

let first;
let last;
let focusables;

let focusTrapped;

/**
 * Toggle the open/close classes for search menu and resource content
 */
function toggleMenu() {
  document.querySelector('.search-menu').classList.toggle('search-menu--open');
  document.querySelector('#block-education-base-content').classList.toggle('block-system-main-block--open');
  document.querySelector('body').classList.toggle('no-scroll');

  isSearchOpen = !isSearchOpen;

  isSearchOpen ? document.getElementById('resource-search-close').focus() : document.getElementById('resource-search-open').focus();

  // set the focus trap listener only once, when the menu is toggled for the first time.
  if (!focusTrapped) {
    focusables = getKeyboardFocusableElements(document.querySelector('.search-menu'));
    first = focusables[0];
    last = focusables[focusables.length - 1];

    window.addEventListener('keydown', (e) => {
      if (!isSearchOpen) return;
      if (e.key === 'Tab') {
        if (document.activeElement === first && e.shiftKey) {
          e.preventDefault();
          last.focus();
        }
        if (document.activeElement === last && !e.shiftKey) {
          e.preventDefault();
          first.focus();
        }
      }
      if (e.key === 'Escape') toggleMenu();
    });

    focusTrapped = true;
  }
}

export function initResourceSearch() {
  const toggles = document.getElementsByClassName('resource-search-toggle');
  toggles.forEach((t) => t.addEventListener('click', toggleMenu));
}

export default 'initResourceSearch';
